import React from 'react';
import PropTypes from 'prop-types';

function LoadingSpinner(props) {
  return <div className={`d-flex h-100 justify-content-center align-items-center p-${props.padding}`}>
    <i className={`fas fa-spin fa-spinner fa-${props.faSize}x`} />
  </div>
}

LoadingSpinner.defaultProps = {
  padding: 5,
  faSize: 2,
};

LoadingSpinner.propTypes = {
  padding: PropTypes.number,
  faSize: PropTypes.number,
};

export default LoadingSpinner;